exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.modal-dialog {\r\n    width:800px;\r\n}\r\n\r\ndiv.help-block {\r\n    color:#dd4b39;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/category-money/edit-category-money/edit-category-money.component.css
// module id = ../../../../../src/app/_components/category-money/edit-category-money/edit-category-money.component.css
// module chunks = main